import { FC } from "react";
import { FaCheck, FaWhatsapp } from "react-icons/fa";
import Image from "next/image";
import { BRAND_NAMES, LOJAS_DATA } from "@/app/utils/utils";

const ExampleSection: FC = () => {
  return (
    <section className="py-12 px-6 bg-white">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-12 text-black">
          Exemplo de Agendamento Finalizado
        </h2>

        {/* Grid com exemplo e confirmação */}
        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto mb-8">
          {/* Card de detalhes */}
          <div className="border border-[#797A7C]  p-6 space-y-4">
            <div className="flex items-center gap-3">
              <FaCheck className="text-[#797A7C]" />
              <span className="text-[#797A7C]">
                Unidade: {BRAND_NAMES.DEFAULT} {LOJAS_DATA[0].nome}
              </span>
            </div>
            <div className="flex items-center gap-3">
              <FaCheck className="text-[#797A7C]" />
              <span className="text-[#797A7C]">Data: 17/01/2025</span>
            </div>
            <div className="flex items-center gap-3">
              <FaCheck className="text-[#797A7C]" />
              <span className="text-[#797A7C]">Horário: 10:30</span>
            </div>
            <div className="flex items-center gap-3">
              <FaCheck className="text-[#797A7C]" />
              <span className="text-[#797A7C]">
                Serviço: Terceira Revisão (até 30.000 km)
              </span>
            </div>
          </div>

          {/* Card de confirmação */}
          <div className="border border-[#797A7C]  p-6">
            <h3 className="text-xl font-medium text-center mb-6 text-black">
              Confirmar?
            </h3>
            <div className="space-y-4">
              <div className="flex items-center gap-3">
                <span className="w-6 h-6  bg-[#797A7C] flex items-center justify-center text-sm text-white">
                  1
                </span>
                <span className="text-[#797A7C]">Sim</span>
              </div>
              <div className="flex items-center gap-3">
                <span className="w-6 h-6  bg-[#797A7C] flex items-center justify-center text-sm text-white">
                  2
                </span>
                <span className="text-[#797A7C]">Não</span>
              </div>
            </div>
          </div>
        </div>

        {/* Texto de confirmação */}
        <div className="text-center mb-12">
          <p className="mb-2 text-black">
            Ao final, você receberá a confirmação do agendamento.
          </p>
          <p className="flex items-center justify-center gap-2 text-black">
            Caso tenha dúvidas, basta retornar ao menu e escolher a opção de
            falar com um atendente.😊
          </p>
        </div>

        {/* Card do WhatsApp com layout responsivo */}
        <div className="bg-[#27272796] filter backdrop-blur-sm text-white p-8 max-w-[520px] mx-auto">
          <div className="flex flex-col md:flex-row items-center gap-4 mb-4">
            <img
              src={`https://sablobsitestoyotaprd.blob.core.windows.net/images/Agendamento/agenda_facil_${BRAND_NAMES.LOWERCASE_PLAIN}.svg`}
              alt="Agenda Fácil"
              width={80}
              height={80}
              className="min-h-[100px]"
            />
            <div className="text-center md:text-left">
              <h3 className="text-2xl mb-2">
                Agende a revisão ou serviço para seu Toyota com mais agilidade e
                comodidade.
              </h3>
            </div>
          </div>

          <div className="flex flex-col items-center text-center">
            <div className="flex items-center gap-2 text-3xl font-bold mb-2">
              <FaWhatsapp />
              <span className="font-bold text-3xl">
                {BRAND_NAMES.NUMERO_POS_VENDA_TRATADO}
              </span>
            </div>
            <p className="text-sm mb-4">
              Nosso whatsapp funciona{" "}
              <span className="font-bold">
                24h por dia,
                <br />7 dias por semana.
              </span>
            </p>
            <a
              href={`https://wa.me/55${BRAND_NAMES.NUMERO_POS_VENDA}`}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#EB0A1E] hover:bg-[#661b22] text-white px-8 py-3 rounded-md flex items-center gap-2 transition-colors"
            >
              AGENDAR AGORA
              <FaWhatsapp />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExampleSection;
